import { combineReducers } from 'redux-immutable';
import { reducer as homeReducer } from '../pages/home/store';
import { reducer as aboutReducer } from '../pages/about-me/store';
import { reducer as achReducer } from '../pages/achievements/store';
import { reducer as techReducer } from '../pages/technology-service/store'
import { reducer as partReducer } from '../pages/partner/store'
import { reducer as resourcesReducer } from '../pages/resources/store';
import { reducer as expertReducer } from '../pages/expertDetail/store';
import { reducer as publishReducer } from '../pages/publish/store';
import { reducer as demandReducer } from '../pages/demand/store';
import { reducer as demandHallReducer } from '../pages/demandHall/store';
import { reducer as detailsReducer } from '../pages/details/store';
import { reducer as caseReducer } from '../pages/case/store';


const reducer = combineReducers({
  home: homeReducer,
  about: aboutReducer,
  ach: achReducer,
  tech: techReducer,
  partner: partReducer,
  resources: resourcesReducer,
  expert: expertReducer,
  publish: publishReducer,
  demand: demandReducer,
  hall: demandHallReducer,
  details: detailsReducer,
  case: caseReducer
});

export default reducer;